import React, { useEffect, useState } from "react";

const BackgroundLetters = ({ count = 50 }) => {
    const [lettersData, setLettersData] = useState([]);
    const [viewport, setViewport] = useState({ width: 0, height: 0 });

    useEffect(() => {
        // Получаем актуальные размеры экрана, чтобы не ловить 0x0 на первом рендере.
        const getViewport = () => {
            const width =
                window.innerWidth || document.documentElement.clientWidth || 0;
            const height =
                window.innerHeight || document.documentElement.clientHeight || 0;
            return { width, height };
        };

        let rafId = 0;

        const updateViewport = () => {
            const next = getViewport();
            setViewport(next);
        };

        // Обновляем размеры после первого кадра, когда DOM уже отрисован.
        rafId = window.requestAnimationFrame(updateViewport);

        window.addEventListener("resize", updateViewport);
        window.addEventListener("orientationchange", updateViewport);

        return () => {
            window.removeEventListener("resize", updateViewport);
            window.removeEventListener("orientationchange", updateViewport);
            window.cancelAnimationFrame(rafId);
        };
    }, []);

    useEffect(() => {
        // Генерируем позиции только когда есть валидные размеры экрана.
        if (!viewport.width || !viewport.height) {
            return;
        }

        const letters = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЭЮЯ".split("");

        const generated = Array.from({ length: count }).map(() => ({
            char: letters[Math.floor(Math.random() * letters.length)],
            left: Math.random() * viewport.width,
            top: Math.random() * viewport.height,
            rotate: Math.random() * 360,
            fontSize: 40 + Math.random() * 40,
            opacity: 0.02 + Math.random() * 0.08,
            duration: 20 + Math.random() * 20, // скорость дрейфа
            delay: Math.random() * 10, // смещение анимации
        }));

        setLettersData(generated);
    }, [count, viewport.height, viewport.width]);

    return (
        <div
            style={{
                position: "fixed",
                width: "100%",
                height: "100%",
                background: "linear-gradient(180deg, var(--app-bg-main), var(--app-bg-main))",
                overflow: "hidden",
                zIndex: 0,
                pointerEvents: "none",
            }}
        >
            {lettersData.map((item, i) => (
                <div
                    key={i}
                    style={{
                        position: "absolute",
                        left: item.left,
                        top: item.top,
                        fontSize: item.fontSize,
                        fontWeight: "bold",
                        color: "var(--app-text-secondary)",
                        opacity: item.opacity,
                        userSelect: "none",
                        pointerEvents: "none",
                        animation: `float ${item.duration}s ease-in-out infinite`,
                        animationDelay: `${item.delay}s`,
                    }}
                >
                    {item.char}
                </div>
            ))}
            <style>
                {`
                    @keyframes float {
                      0%   { transform: translate(0, 0); }
                      50%  { transform: translate(-60px, 60px); }
                      100% { transform: translate(0, 0); }
                    }
                `}
            </style>
        </div>
    );
};

export default BackgroundLetters;
